import script from "./MsgReply.vue?vue&type=script&setup=true&lang=ts"
export * from "./MsgReply.vue?vue&type=script&setup=true&lang=ts"

import "./MsgReply.vue?vue&type=style&index=0&id=9f268e98&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f268e98"]])

export default __exports__